import { Config, useLatestSearches } from 'hooks/useLatestSearches'
import { useEffect } from 'react'

export function useSaveSearchedIds(
  id: number,
  config: Pick<Config, 'entities' | 'key'>
) {
  const { saveSearchedIds } = useLatestSearches({
    entities: config.entities,
    key: config.key,
    computeEntities: false,
    computeIds: false,
  })

  useEffect(() => {
    saveSearchedIds(id)
  }, [id])
}
